<template>
  <div>
    <base-table :data="positions" thead-classes="text-primary">
      <template slot="columns" slot-scope="{ columns }">
        <th @click="updateSort('name')">
          Instrument
          <sort-caret
            :name="'name'"
            :current="sort.current"
            :status="sort.order"
          ></sort-caret>
          <br />&nbsp;
        </th>
        <th class="text-center d-none d-md-table-cell">Actions<br />&nbsp;</th>
        <th class="text-right" @click="updateSort('variation')">
          Cours
          <br /><small
            >Variation jour
            <sort-caret
              :name="'variation'"
              :current="sort.current"
              :status="sort.order"
            ></sort-caret
          ></small>
        </th>
        <th
          class="text-right"
          title="Prix de Revient Unitaire"
          @click="updateSort('perf')"
        >
          PRU
          <br /><small
            >± values
            <sort-caret
              :name="'perf'"
              :current="sort.current"
              :status="sort.order"
            ></sort-caret
          ></small>
        </th>
        <th
          class="text-right"
          @click="updateSort('stop')"
          v-if="!conf.hideStop"
        >
          Stop
          <br /><small
            >Proximité
            <sort-caret
              :name="'stop'"
              :current="sort.current"
              :status="sort.order"
            ></sort-caret
          ></small>
        </th>
        <th
          class="text-center d-none d-md-table-cell"
          @click="updateSort('quantity')"
        >
          Quantité
          <sort-caret
            :name="'quantity'"
            :current="sort.current"
            :status="sort.order"
          ></sort-caret>
          <br />&nbsp;
        </th>
        <th class="text-right">
          Valeur
          <br /><small @click="updateSort('pv')"
            >± values
            <sort-caret
              :name="'pv'"
              :current="sort.current"
              :status="sort.order"
            ></sort-caret
          ></small>
        </th>
        <th
          class="text-center d-none d-md-table-cell"
          @click="updateSort('capitalPercent')"
        >
          % Capital
          <sort-caret
            :name="'capitalPercent'"
            :current="sort.current"
            :status="sort.order"
          ></sort-caret>
          <br />&nbsp;
        </th>
      </template>

      <template slot-scope="{ row, index }" v-if="row.info">
        <td>
          {{ row.info.na }}<br />
          <market :name="row.info.mk"></market>
          <small title="Symbole">{{ row.info.sy }}</small>
          <div class="text-left d-block d-md-none">
            <el-tooltip
              content="Afficher le graphique"
              effect="light"
              :open-delay="200"
              placement="top"
            >
              <base-button
                type="primary"
                icon
                size="sm"
                class="btn-link"
                @click.native="
                  modals.graph = true;
                  currentInstrument = row.info;
                "
              >
                <i class="tim-icons icon-chart-bar-32"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip
              content="Position et calculette"
              effect="light"
              :open-delay="200"
              placement="top"
            >
              <base-button
                type="primary"
                icon
                size="sm"
                class="btn-link"
                @click.native="
                  modals.position = true;
                  currentInstrument = row.info;
                "
              >
                <i class="tim-icons icon-cart"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip
              content="Consulter les notes"
              effect="light"
              :open-delay="200"
              placement="top"
            >
              <base-button
                type="primary"
                icon
                size="sm"
                class="btn-link"
                @click.native="
                  modals.notes = true;
                  currentInstrument = row.info;
                "
              >
                <i class="tim-icons icon-notes"></i>
              </base-button>
            </el-tooltip>
          </div>
        </td>
        <td class="text-center d-none d-md-table-cell">
          <el-tooltip
            content="Afficher le graphique hebdo"
            effect="light"
            :open-delay="200"
            placement="top"
          >
            <base-button
              type="primary"
              icon
              size="sm"
              class="btn-link"
              @click.native="
                modals.graph = true;
                currentInstrument = row.info;
              "
            >
              <i class="tim-icons icon-chart-bar-32"></i>
            </base-button>
          </el-tooltip>
          <el-tooltip
            content="Position et calculette"
            effect="light"
            :open-delay="200"
            placement="top"
          >
            <base-button
              type="primary"
              icon
              size="sm"
              class="btn-link"
              @click.native="
                modals.position = true;
                currentInstrument = row.info;
              "
            >
              <i class="tim-icons icon-cart"></i>
            </base-button>
          </el-tooltip>
          <el-tooltip
            content="Consulter et saisir des notes"
            effect="light"
            :open-delay="200"
            placement="top"
          >
            <base-button
              type="primary"
              icon
              size="sm"
              class="btn-link"
              @click.native="
                currentInstrument = row.info;
                modals.notes = true;
              "
            >
              <i class="tim-icons icon-notes"></i>
            </base-button>
          </el-tooltip>
        </td>
        <td class="text-right">
          <el-tooltip
            :content="$moment(row.info.li.lt * 1000).format('llll')"
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <span>
              {{
                row.info.li.last
                  | currency({
                    symbol: $currency(mode),
                    fractionCount: row.info.pd
                  })
              }}</span
            >
          </el-tooltip>
          <br />
          <el-tooltip
            :content="
              `± values journalières de 
              ${(row.quantity * row.diff).toFixed(2)}${$currency(mode)}`
            "
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <span
              class="text-success"
              v-bind:class="{ 'text-danger': row.dailyPercent < 0 }"
            >
              {{ row.dailyPercent }} %
            </span>
          </el-tooltip>
        </td>
        <td class="text-right">
          <span class="d-inline d-md-none">{{ row.quantity }}@ </span
          >{{
            row.value
              | currency({
                symbol: $currency(mode),
                fractionCount: row.info.pd
              })
          }}<br />
          <span
            class="text-success"
            v-bind:class="{ 'text-danger': row.pv < 0 }"
          >
            {{ row.pruPercent }} %
          </span>
        </td>
        <td class="text-right" v-if="!conf.hideStop">
          <el-tooltip
            :content="
              $options.filters.currency(row.quantity * (row.stop - row.value), {
                symbol: $currency(mode)
              }) + ' de ± values sécurisées'
            "
            effect="light"
            :open-delay="200"
            placement="top"
          >
            <span>{{
              row.stop
                | currency({
                  symbol: $currency(mode),
                  fractionCount: row.info.pd
                })
            }}</span>
          </el-tooltip>
          <br />
          <span class="text-muted">{{ row.stopPercent }} %</span>
          <el-tooltip
            :content="
              'Stop à plus de ' +
                (mode === 'crypto' ? '25' : '10') +
                '% du cours'
            "
            effect="light"
            :open-delay="200"
            placement="right"
          >
            <i
              v-if="row.stopPercent > (mode === 'crypto' ? 25 : 10)"
              class="text-danger tim-icons icon-alert-circle-exc ml-1"
            ></i>
          </el-tooltip>
        </td>
        <td
          class="text-center d-none d-md-table-cell"
          v-bind:class="{ 'text-blur': hideAmount }"
        >
          {{ row.quantity }}
        </td>
        <td class="text-right" v-bind:class="{ 'text-blur': hideAmount }">
          {{
            (row.quantity * row.info.li.last)
              | currency({ symbol: $currency(mode) })
          }}<br />
          <span
            v-if="!hideAmount"
            class="text-success"
            v-bind:class="{ 'text-danger': row.pv < 0 }"
          >
            {{ row.pv | currency({ symbol: $currency(mode) }) }}
          </span>
        </td>
        <td class="text-center pl-5 d-none d-md-table-cell">
          <base-progress :value="row.capitalPercent" />
        </td>
      </template>
    </base-table>

    <modal :show-close="true" :show.sync="modals.graph" class="modal-graph">
      <trading-graph
        :instrument="currentInstrument"
        :use-conf="true"
      ></trading-graph>
    </modal>

    <modal
      :show-close="true"
      :show.sync="modals.position"
      class="modal-position"
    >
      <position
        v-if="currentInstrument"
        :instrument="currentInstrument"
      ></position>
    </modal>
    <modal :show-close="true" :show.sync="modals.notes" class="modal-position">
      <h4 v-if="currentInstrument">
        Prise de notes pour {{ currentInstrument.na }}
      </h4>
      <notes-table
        v-if="currentInstrument"
        :instrument="currentInstrument"
      ></notes-table>
    </modal>
    <div v-if="!positions.length" class="text-center">
      Commencer à saisir les valeurs de votre portefeuille en accédant à la
      <router-link class="pointer text-primary" tag="b" to="/instruments"
        >liste des instruments</router-link
      >,<br />
      ou recherchez des valeurs en utilisant les
      <router-link class="pointer text-primary" tag="b" to="/screeners"
        >screeners</router-link
      >.
    </div>
  </div>
</template>
<script>
import {
  BaseTable,
  BaseProgress,
  Modal,
  TradingGraph,
  Market
} from "@/components";
import { mapGetters } from "vuex";
import Position from "../Pages/Instruments/Position";
import SortCaret from "../../components/Tables/SortCaret";
import NotesTable from "../Pages/Instruments/NotesTable";

export default {
  components: {
    NotesTable,
    BaseTable,
    BaseProgress,
    Modal,
    TradingGraph,
    Position,
    SortCaret,
    Market
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist",
      conf: "auth/conf",
      mode: "auth/mode"
    })
  },
  props: {
    hideAmount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      positions: [],
      modals: {
        graph: false,
        position: false,
        notes: false
      },
      currentInstrument: null,
      sort: {
        current: "",
        order: 0
      }
    };
  },
  methods: {
    updateTable() {
      const pos = this.$store.getters["instruments/addInfoToList"](
        this.conf.positions
      ).filter(p => !!p.info);
      const totalPortfolio = this.$store.getters["instruments/totalPortfolio"](
        this.conf
      );
      this.positions = pos
        .filter(p => !!p.info)
        .map(p => {
          const lc = p.info.li.c || p.info.li.o;
          const last = p.info.li.last || p.info.li.c;
          const diff = last - lc;
          const dailyPercent = !lc
            ? 0
            : parseFloat((diff / lc) * 100).toFixed(2);
          const pruPercent = Number(
            ((p.info.li.last - p.value) / p.value) * 100
          ).toFixed(2);
          const stopPercent = Number(
            ((p.info.li.last - p.stop) / p.info.li.last) * 100
          ).toFixed(2);
          const pv = (p.info.li.last - p.value) * p.quantity;
          const capitalPercent =
            parseInt(((p.info.li.last * p.quantity) / totalPortfolio) * 1000) /
            10;
          return {
            ...p,
            dailyPercent,
            pruPercent,
            stopPercent,
            pv,
            capitalPercent,
            diff
          };
        })
        .sort((a, b) => {
          if (!this.sort.current || this.sort.current === "name") {
            return a.info.na.localeCompare(b.info.na) * this.sort.order;
          }
          if (this.sort.current === "variation") {
            return (a.dailyPercent - b.dailyPercent) * this.sort.order;
          }
          if (this.sort.current === "perf") {
            return (a.pruPercent - b.pruPercent) * this.sort.order;
          }
          if (this.sort.current === "stop") {
            return (a.stopPercent - b.stopPercent) * this.sort.order;
          }
          if (this.sort.current === "quantity") {
            return (a.quantity - b.quantity) * this.sort.order;
          }
          if (this.sort.current === "value") {
            return (
              (a.quantity * a.info.li.last - b.quantity * b.info.li.last) *
              this.sort.order
            );
          }
          if (this.sort.current === "pv") {
            return (a.pv - b.pv) * this.sort.order;
          }
          if (this.sort.current === "capitalPercent") {
            return (a.capitalPercent - b.capitalPercent) * this.sort.order;
          }
        });
    },
    updateSort(sortOn) {
      if (sortOn !== this.sort.current) {
        this.sort.current = sortOn;
        this.sort.order = 1;
      } else {
        this.sort.order = this.sort.order * -1;
      }
      this.updateTable();
    }
  },
  mounted() {
    this.updateTable();
  },
  watch: {
    livelist(newValue, oldValue) {
      this.updateTable();
    },
    conf(newValue, oldValue) {
      this.updateTable();
    }
  }
};
</script>
<style></style>
